import { DeprecatedNumber, type NumberOtherProps } from "@octopusdeploy/design-system-octopus-components";
import { withBoundField } from "~/components/form/BoundField/BoundField";
export const BoundNumber = withBoundField<number | undefined, NumberOtherProps>(DeprecatedNumber);
